import React, { useEffect, useState } from "react";
import "../styles/components/acteurDetails.scss";
import axios from "axios";
import Footer from "../components/footer";
import Header from "../components/header";
import Actor from "../components/Actor";
import { Splide, SplideSlide } from "@splidejs/react-splide";
import "@splidejs/splide/dist/css/splide.min.css";
import "../styles/components/movieDetails.scss";
import { useHistory, useParams } from "react-router-dom";

const ActorDetails = () => {
  const history = useHistory();
  const { id } = useParams();
  const [detail, setDetail] = useState({});
  const [credits, setCredits] = useState([]);

  // recupere les detils de l'acteur
  useEffect(() => {
    const URL = `https://api.themoviedb.org/3/person/${id}?api_key=${process.env.REACT_APP_TMDB_API_KEY}&language=fr-FR`;

    axios.get(URL).then((res) => setDetail(res.data));
  }, [id]);

  // recupere les films joué par l'acteur
  useEffect(() => {
    const URL = `https://api.themoviedb.org/3/person/${id}/movie_credits?api_key=${process.env.REACT_APP_TMDB_API_KEY}&language=fr-FR`;

    axios.get(URL).then((res) => setCredits(res.data.cast));
  }, [id]);

  if (!id) {
    return <div>Invalid movie ID</div>;
  }

  return (
    <React.Fragment>
      <Header />
      <header className="header_acteur">
        <div className="detail-acteur">
          <div className="row">
            <div className="col-md-7 col-lg-8 col-xl-9">
              <div className="detail">
                <h1>{detail.name}</h1>
                <div className="fiche-detail d-flex element-film">
                  <div className="fiche-categorie">Biographie</div>
                </div>
                <div>{detail.biography}</div>
              </div>
              <div className="carrousel_acteur-film">
                <div className="tendances-carrousel">
                  <Splide
                    options={{
                      perPage: 1,
                      autoplay: true,
                      interval: 3500,
                      rewind: true,
                      speed: 2500,
                      pagination: false,
                      arrows: false,
                      drag: true,
                      updateOnMove: true,
                      gap: "15px",
                    }}
                  >
                    {credits.slice(0, 12).map((movie) => (
                      <SplideSlide key={movie.id}>
                        <Actor
                          actor={movie}
                          type="movie"
                          onClickActor={() =>
                            history.push(`/movieDetails/${movie.id}`)
                          }
                        />
                      </SplideSlide>
                    ))}
                  </Splide>
                </div>
              </div>
            </div>
            <div className="p_acteur_acteur col-md-5 col-lg-4 col-xl-3">
              <img
                src={`https://image.tmdb.org/t/p/original${detail.profile_path}`}
                alt="poster"
              />
            </div>
          </div>
        </div>
      </header>
      <Footer />
    </React.Fragment>
  );
};

export default ActorDetails;
